import { MicroTask } from 'src/app/models/OLE/micro-task';
import { ProductDetail } from 'src/app/models/ProductModels/productDetail';

export const PRODUCTS: ProductDetail[] = [
    { productId: 1, productGroup: 'BCG', productPlant: 'BCG Plant 1', productFamily: 'Printing', productCode: 1232323, productDescription: 'Almarai_Test Product3' },
    { productId: 1, productGroup: 'BCG', productPlant: 'BCG Plant 1', productFamily: 'Printing', productCode: 1232323, productDescription: 'Almarai_Test Product3' },
    { productId: 1, productGroup: 'BCG', productPlant: 'BCG Plant 1', productFamily: 'Printing', productCode: 1232323, productDescription: 'Almarai_Test Product3' },
    { productId: 1, productGroup: 'BCG', productPlant: 'BCG Plant 1', productFamily: 'Printing', productCode: 1232323, productDescription: 'Almarai_Test Product3' },
    { productId: 1, productGroup: 'BCG', productPlant: 'BCG Plant 1', productFamily: 'Printing', productCode: 1232323, productDescription: 'Almarai_Test Product3' },
];

// export const MiCROTASKS: MicroTask[] = [
//     {
//         id: 1, operator: 'Operator 1', microHours: [
//             { id: 1, firstHalf: '#10ce9c', secondHalf: '#f85439' },
//             { id: 2, firstHalf: '#10ce9c', secondHalf: '#10ce9c' },
//             { id: 3, firstHalf: '#10ce9c', secondHalf: '#10ce9c' },
//             { id: 4, firstHalf: '#10ce9c', secondHalf: '#10ce9c' },
//             { id: 5, firstHalf: '#ece905', secondHalf: '#10ce9c' },
//             { id: 6, firstHalf: '#f85439', secondHalf: '#f85439' },
//             { id: 7, firstHalf: '#f85439', secondHalf: '#ece905' },
//             { id: 8, firstHalf: '#10ce9c', secondHalf: '#10ce9c' },
//             { id: 9, firstHalf: '#ece905', secondHalf: '#f85439' },
//             { id: 10, firstHalf: '#10ce9c', secondHalf: '#ece905' },
//             { id: 11, firstHalf: '#10ce9c', secondHalf: '#10ce9c' },
//             { id: 12, firstHalf: '#ece905', secondHalf: '#ece905' },
//             { id: 13, firstHalf: '#10ce9c', secondHalf: '#10ce9c' },
//             { id: 14, firstHalf: '#f85439', secondHalf: '#10ce9c' },
//             { id: 15, firstHalf: '#10ce9c', secondHalf: '#f85439' },
//             { id: 16, firstHalf: '#f85439', secondHalf: '#f85439' },
//             { id: 17, firstHalf: '#10ce9c', secondHalf: '#10ce9c' },
//             { id: 18, firstHalf: '#ece905', secondHalf: '#f85439' },
//             { id: 19, firstHalf: '#ece905', secondHalf: '#f85439' },
//             { id: 20, firstHalf: '#ece905', secondHalf: '#f85439' },
//             { id: 21, firstHalf: '#10ce9c', secondHalf: '#ece905' },
//             { id: 22, firstHalf: '#10ce9c', secondHalf: '#ece905' },
//             { id: 23, firstHalf: '#f85439', secondHalf: '#10ce9c' },
//             { id: 24, firstHalf: '#10ce9c', secondHalf: '#10ce9c' },
//         ]
//     },
//     {
//         id: 2, operator: 'Operator 2', microHours: [
//             { id: 25, firstHalf: '#ece905', secondHalf: '#10ce9c' },
//             { id: 26, firstHalf: '#10ce9c', secondHalf: '#10ce9c' },
//             { id: 27, firstHalf: '#10ce9c', secondHalf: '#f85439' },
//             { id: 28, firstHalf: '#ece905', secondHalf: '#ece905' },
//             { id: 29, firstHalf: '#ece905', secondHalf: '#10ce9c' },
//             { id: 30, firstHalf: '#f85439', secondHalf: '#f85439' },
//             { id: 31, firstHalf: '#ece905', secondHalf: '#ece905' },
//             { id: 32, firstHalf: '#10ce9c', secondHalf: '#ece905' },
//             { id: 33, firstHalf: '#ece905', secondHalf: '#f85439' },
//             { id: 34, firstHalf: '#f85439', secondHalf: '#ece905' },
//             { id: 35, firstHalf: '#10ce9c', secondHalf: '#10ce9c' },
//             { id: 36, firstHalf: '#f85439', secondHalf: '#ece905' },
//             { id: 37, firstHalf: '#10ce9c', secondHalf: '#10ce9c' },
//             { id: 38, firstHalf: '#10ce9c', secondHalf: '#10ce9c' },
//             { id: 39, firstHalf: '#ece905', secondHalf: '#ece905' },
//             { id: 40, firstHalf: '#10ce9c', secondHalf: '#f85439' },
//             { id: 41, firstHalf: '#f85439', secondHalf: '#f85439' },
//             { id: 42, firstHalf: '#ece905', secondHalf: '#f85439' },
//             { id: 43, firstHalf: '#f85439', secondHalf: '#f85439' },
//             { id: 44, firstHalf: '#ece905', secondHalf: '#f85439' },
//             { id: 45, firstHalf: '#f85439', secondHalf: '#ece905' },
//             { id: 46, firstHalf: '#10ce9c', secondHalf: '#ece905' },
//             { id: 47, firstHalf: '#10ce9c', secondHalf: '#10ce9c' },
//             { id: 48, firstHalf: '#10ce9c', secondHalf: '#10ce9c' },
//         ]
//     },
//     {
//         id: 3, operator: 'Operator 3', microHours: [
//             { id: 49, firstHalf: '#10ce9c', secondHalf: '#ece905' },
//             { id: 50, firstHalf: '#10ce9c', secondHalf: '#10ce9c' },
//             { id: 51, firstHalf: '#10ce9c', secondHalf: '#ece905' },
//             { id: 52, firstHalf: '#10ce9c', secondHalf: '#ece905' },
//             { id: 53, firstHalf: '#ece905', secondHalf: '#10ce9c' },
//             { id: 54, firstHalf: '#10ce9c', secondHalf: '#f85439' },
//             { id: 55, firstHalf: '#f85439', secondHalf: '#ece905' },
//             { id: 56, firstHalf: '#10ce9c', secondHalf: '#f85439' },
//             { id: 57, firstHalf: '#ece905', secondHalf: '#f85439' },
//             { id: 58, firstHalf: '#ece905', secondHalf: '#f85439' },
//             { id: 59, firstHalf: '#10ce9c', secondHalf: '#10ce9c' },
//             { id: 60, firstHalf: '#10ce9c', secondHalf: '#f85439' },
//             { id: 61, firstHalf: '#f85439', secondHalf: '#10ce9c' },
//             { id: 62, firstHalf: '#10ce9c', secondHalf: '#10ce9c' },
//             { id: 63, firstHalf: '#10ce9c', secondHalf: '#10ce9c' },
//             { id: 64, firstHalf: '#10ce9c', secondHalf: '#10ce9c' },
//             { id: 65, firstHalf: '#f85439', secondHalf: '#10ce9c' },
//             { id: 66, firstHalf: '#ece905', secondHalf: '#10ce9c' },
//             { id: 67, firstHalf: '#10ce9c', secondHalf: '#10ce9c' },
//             { id: 68, firstHalf: '#f85439', secondHalf: '#ece905' },
//             { id: 69, firstHalf: '#ece905', secondHalf: '#10ce9c' },
//             { id: 70, firstHalf: '#ece905', secondHalf: '#10ce9c' },
//             { id: 71, firstHalf: '#f85439', secondHalf: '#10ce9c' },
//             { id: 72, firstHalf: '#10ce9c', secondHalf: '#10ce9c' },
//         ]
//     }
// ];


